import {
  signOut,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  onAuthStateChanged
} from 'firebase/auth'
import {
  query as f_query,
  where as f_where,
  limit as f_limit,
  orderBy,
  doc as f_doc,
  collection,
  updateDoc,
  getDocs,
  getDoc,
  setDoc,
  deleteDoc,
  onSnapshot,
  serverTimestamp,
  startAfter as f_startAfter
} from 'firebase/firestore'
import {
  ref as f_ref,
  listAll,
  getDownloadURL,
  deleteObject,
  uploadBytes
} from 'firebase/storage'
import { httpsCallable } from 'firebase/functions'
import { get_firebase_instances } from '@/plugins/firebase'

export const { db, functions, storage, auth } = get_firebase_instances()

// i didn't seem to be able to delete id but now i see it's not being set.
// maybe I have to restart the server?
const convert = {
  toFirestore: model => model,
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options)
    if (!data) return null
    return {
      ...data,
      id: snapshot.id
    }
  }
}

export const callable = (name: string) => httpsCallable(functions, name)

export const users = collection(db, 'users').withConverter(convert)
export const projects = collection(db, 'projects').withConverter(convert)
export const plans = collection(db, 'plans').withConverter(convert)
export const stories = collection(db, 'stories').withConverter(convert)
export const companies = collection(db, 'companies').withConverter(convert)
export const predictions = collection(db, 'predictions').withConverter(convert)
export const tasks = collection(db, 'tasks').withConverter(convert)
export const participants = (project_id: string) =>
  collection(db, `projects/${project_id}/participants`).withConverter(convert)
export const staff = (company_id: string) =>
  collection(db, `companies/${company_id}/staff`).withConverter(convert)

export const doc = (id: string) => f_doc(db, id).withConverter(convert)
export const ref_doc = collectionRef =>
  f_doc(collectionRef).withConverter(convert)
export const set_doc = (ref, data) => setDoc(ref, data)
export const load = ref => getDoc(ref)
export const list = queryOrRef => getDocs(queryOrRef)
export const files = path => listAll(f_ref(storage, path))
export const file_url = path => getDownloadURL(f_ref(storage, path))
export const file_upload = (path, file, metadata) =>
  uploadBytes(f_ref(storage, path), file, metadata)
export const file_remove = path => deleteObject(f_ref(storage, path))
export const update = (ref, data) => updateDoc(ref, data)
export const remove = ref => deleteDoc(ref)
export const sign_out = () => {
  signOut(auth)
  sessionStorage.removeItem('relations')
  sessionStorage.removeItem('project')
}
export const order_by = orderBy
export const limit = f_limit
export const where = f_where
export const query = (...args: Parameters<typeof f_query>) =>
  f_query(...args).withConverter(convert)
export const server_time = serverTimestamp
export const listen = (ref, callback) => onSnapshot(ref, callback)
export const verifier = RecaptchaVerifier
export const sign_in_mobile = signInWithPhoneNumber
export const savable_date = server_time
export const auth_changed = onAuthStateChanged
export const start_after = f_startAfter
